import { render, staticRenderFns } from "./CustomDatePickerMonth.vue?vue&type=template&id=1a97a1e0"
import script from "./CustomDatePickerMonth.vue?vue&type=script&lang=js"
export * from "./CustomDatePickerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports